<app-content-header i18n-title title="Offer Messages" i18n-subTitle
                    subTitle="An overview of all offer related messages"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>
<div class="content">
  <div class="row">
    <div class="col-md-3">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>

        <!-- -->
        <div class="block-content block-content-full">
          <form [formGroup]="form" (ngSubmit)="loadOfferMessages()">
            <div class="row">
              <label class="col-12" for="state">State</label>
              <div class="col-12">
                <select class="form-control" formControlName="state" id="state">
                  <option value="">Please select..</option>
                  <option value="NEW">New (Team not notified)</option>
                  <option value="WAITING_FOR_TEAM">New (Team notified)</option>
                  <option value="SENDING_EMAIL_FROM_TEAM">Send Email (Partner)</option>
                  <option value="SENDING_EMAIL_FROM_TEAM_FAILED">Send Email Failed (Partner)</option>
                  <option value="WAITING_FOR_RESPONSE">Waiting for Response</option>
                  <option value="FINISHED">Finished</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="requestId">RequestId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="RequestId"
                       autocomplete="off"
                       id="requestId"
                       formControlName="requestId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="requestId">OfferId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="OfferId"
                       autocomplete="off"
                       id="offerId"
                       formControlName="offerId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="requestId">HousingId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="HousingId"
                       autocomplete="off"
                       id="housingId"
                       formControlName="housingId">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button class="btn btn-info btn-sm" type="submit">Apply Filter</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Messages</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Id</th>
                <th>RequestId</th>
                <th>OfferId</th>
                <th>HousingId</th>
                <th>Housing</th>
                <th>State</th>
                <th>CreatedAt</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody *ngIf="offerMessages != null && pagination != null">
              <tr *ngFor="let message of offerMessages | paginate: {
              itemsPerPage: pagination.limit,
              currentPage: pagination.page,
              totalItems: pagination.total}"
              >
                <td>{{message.messages._id}}</td>
                <td>{{message.request}}</td>
                <td>{{message.offerId}}</td>
                <td>{{message.housing._id}}</td>
                <td>{{message.housing.name}}</td>
                <td>
                  <span class="badge badge-warning" *ngIf="message.messages.state === 'NEW'">New (Team not notified)</span>
                  <span class="badge badge-info" *ngIf="message.messages.state === 'WAITING_FOR_TEAM'">New (Team notified)</span>
                  <span class="badge badge-warning" *ngIf="message.messages.state === 'SENDING_EMAIL_FROM_TEAM'">Send Email (Partner)</span>
                  <span class="badge badge-danger" *ngIf="message.messages.state === 'SENDING_EMAIL_FROM_TEAM_FAILED'">Send Email Failed (Partner)</span>
                  <span class="badge badge-info" *ngIf="message.messages.state === 'WAITING_FOR_RESPONSE'">Waiting for Response</span>
                  <span class="badge badge-success" *ngIf="message.messages.state === 'FINISHED'">Finished</span>
                </td>
                <td>{{message.messages.created}}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="requestChangeRequestDetails(message.offerId, message.messages._id)">
                    Edit
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="block-content block-content-sm bg-body-light font-size-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
                               *ngIf="pagination != null">

          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<tripmakery-offer-messages-edit-modal></tripmakery-offer-messages-edit-modal>
